import React, { useEffect } from 'react';
import { SocialProofBar } from './components/SocialProofBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Problem } from './components/Problem';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#FDFAF6] overflow-x-hidden" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=849651377704810&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <SocialProofBar data-id="element-3" />
      <Nav data-id="element-4" />
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <TrustBar data-id="element-7" />
        <Problem data-id="element-8" />
        <WhyItDidntWork data-id="element-9" />
        <Mechanism data-id="element-10" />
        <WhatYouGet data-id="element-11" />
        <Testimonials data-id="element-12" />
        <ForWhom data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}